module.exports = __webpack_public_path__ + "static/media/Legendas.85f36399.svg";